import {
  buildGradingOutcome,
  getOutcomeValueFromDefinitionAndGrading,
} from "@repo/app-types/entities/outcome";
import {
  getOutcomeDefinitionFromPlaybook,
  type AdminApiPlaybook,
} from "@repo/app-types/entities/playbook";
import type { PlaybookTestSpecExpected } from "@repo/app-types/entities/teammateAgent";
import {
  SimpleSelect,
  type SimpleSelectOption,
} from "@repo/ui/Select/simpleSelect";
import { useMemo, type FC } from "react";

interface PlaybookTestSpecExpectedOutcomeSelectorProps {
  playbook: AdminApiPlaybook;
  expected: PlaybookTestSpecExpected;
  onChange: (newExpected: PlaybookTestSpecExpected) => void;
}

export const PlaybookTestSpecExpectedOutcomeSelector: FC<
  PlaybookTestSpecExpectedOutcomeSelectorProps
> = ({ playbook, expected, onChange }) => {
  const outcomeDefinition = getOutcomeDefinitionFromPlaybook(playbook);

  const options: readonly SimpleSelectOption<string>[] = useMemo(() => {
    if (!outcomeDefinition) {
      return [];
    }

    return [
      { label: "None", value: "none" },
      ...outcomeDefinition.results.map((result) => ({
        label: result.label,
        value: result.value,
      })),
    ];
  }, [outcomeDefinition]);

  if (!outcomeDefinition) {
    return null;
  }

  const selectedValue =
    getOutcomeValueFromDefinitionAndGrading(
      outcomeDefinition,
      expected.outcomes,
    ) ?? "none";

  return (
    <div className="rounded-md border border-border-light bg-white">
      <div className="flex items-center gap-3 px-4 py-2.5">
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-foreground">
            Outcome: {outcomeDefinition.name}
          </div>
        </div>
        <div className="w-48 shrink-0">
          <SimpleSelect
            options={options}
            value={selectedValue}
            onChange={(value) =>
              onChange({
                ...expected,
                outcomes: buildGradingOutcome(
                  outcomeDefinition,
                  value === "none" ? undefined : value,
                ),
              })
            }
          />
        </div>
      </div>
    </div>
  );
};
